import React from 'react';
import { useSelector } from 'react-redux';

const Messages = () => {
  const { selectedSeekerDetails } = useSelector(state => state.dataFlow);

  return <>Messages - {selectedSeekerDetails?.attendees?.user?.firstName}</>;
};

export default Messages;
